import dayjs from 'dayjs';

// The seven presets from the (never-wired) reference implementation
// (CORE-THEME history: SourceCandidatePage.jsx dateMenuItems), plus the two
// multi-month windows recruiters actually work in. Order is chronological, so
// the new pair sits between "Last 30 Days" and the calendar-month entries.
export const DATE_RANGE_PRESETS = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'last7', label: 'Last 7 Days' },
  { key: 'last30', label: 'Last 30 Days' },
  { key: 'last3Months', label: 'Last 3 Months' },
  { key: 'last6Months', label: 'Last 6 Months' },
  { key: 'thisMonth', label: 'This Month' },
  { key: 'lastMonth', label: 'Last Month' },
  { key: 'custom', label: 'Custom Range' },
];

export const DATE_FORMAT = 'YYYY-MM-DD';

// Mirrors the day-boundary style DynamicFieldFilter.jsx's DATE_SHORTCUTS
// already uses (subtract(6,'day') for "last 7", startOf('month') for "this
// month"), so the two date-shortcut UIs in the app agree on what "last 7
// days" actually means.
export function resolvePresetRange(preset) {
  const now = dayjs();
  switch (preset) {
    case 'today':
      return [now.startOf('day'), now.endOf('day')];
    case 'yesterday': {
      const yesterday = now.subtract(1, 'day');
      return [yesterday.startOf('day'), yesterday.endOf('day')];
    }
    case 'last7':
      return [now.subtract(6, 'day').startOf('day'), now.endOf('day')];
    case 'last30':
      return [now.subtract(29, 'day').startOf('day'), now.endOf('day')];
    // Calendar months back from today rather than 90/180 days, which is what
    // "3 months" means to the person reading it. Inclusive of today, like the
    // day-count presets above.
    case 'last3Months':
      return [now.subtract(3, 'month').startOf('day'), now.endOf('day')];
    case 'last6Months':
      return [now.subtract(6, 'month').startOf('day'), now.endOf('day')];
    case 'thisMonth':
      return [now.startOf('month'), now.endOf('day')];
    case 'lastMonth': {
      const lastMonth = now.subtract(1, 'month');
      return [lastMonth.startOf('month'), lastMonth.endOf('month')];
    }
    default:
      return [null, null];
  }
}

// Plain display formatter. NOT for filter values — see the two below.
export function toDateString(value) {
  return value ? dayjs(value).format(DATE_FORMAT) : null;
}

// Both range ends are sent as full ISO instants rather than bare 'YYYY-MM-DD'
// strings, because the backend (Be_Auth_DevOps models/moduleDataList.go
// castFilterValue) reads a bare date as MIDNIGHT UTC. That silently clipped
// both ends for anyone not on UTC:
//
//   to   → "2026-08-14" meant 00:00, excluding everything created that day
//   from → "2026-08-02" meant 05:30 IST, excluding that morning
//
// A full instant lands on castFilterValue's RFC3339 branch instead, so both
// ends agree that a "day" is the user's local calendar day.
export function toEndOfDayString(value) {
  return value ? dayjs(value).endOf('day').toISOString() : null;
}

export function toStartOfDayString(value) {
  return value ? dayjs(value).startOf('day').toISOString() : null;
}
